@import '../../../constants/spacing.module';

.demo-tooltip-star {
  display: block;
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  margin-left: @space-8;
  cursor: pointer;
  flex-shrink: 0;
}
